import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { VisibilityProvider } from './providers/VisibilityProvider.jsx';

import Landing_page from './landing_page/Landing_page.jsx';

function App() {
  return (
    <Router>
      <VisibilityProvider>
        <Routes>
          <Route path="/" element={<Landing_page />} />
        </Routes>
      </VisibilityProvider>
    </Router>
  );
}

export default App;
